import ProcessTransactionRequestModelBase from '../_generated/modelBases/process-transaction-request-model-base';

export default class ProcessTransactionRequestModel extends ProcessTransactionRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
